import { modal } from "./modules/_modal3.0";
new modal();

